import React from 'react';
import { NavLink } from 'react-router-dom';

import promotionConfig from '../../../promotionConfig';

const PrimaryNav = ({ className = '' }) => {
    const menuLinks = promotionConfig?.headerPrimaryNavLinks ?? [];

    return (
        <div className={`navbar-wrapper ${className}`}>
            <nav className='navbar' id='primary-nav'>
                <div className='navbar-nav'>
                    {menuLinks.map((link, key) => {
                        return (
                            <li className='nav-item nav-link' key={`main-menu--${key}`}>
                                <NavLink to={link.uri} activeClassName='active'>
                                    {link?.title}
                                </NavLink>
                            </li>
                        );
                    })}
                </div>
            </nav>
        </div>
    );
};

export default PrimaryNav;
